import { useEffect, useState, useRef } from "react";
import Robot from "resources/images/robot.png";
import { standardMsgs } from "./constants";

function shuffleArray(array: string[]) {
  const clone = [...array];
  for (let i = clone.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [clone[i], clone[j]] = [clone[j], clone[i]];
  }
  return clone;
}

function useRotatingMessage(messages: string[], interval = 3000) {
  const [msgIndex, setMsgIndex] = useState(0);
  const [fade, setFade] = useState(true);
  const shuffledMessages = useRef(shuffleArray(messages)).current;

  useEffect(() => {
    const id = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setMsgIndex((i) => (i + 1) % shuffledMessages.length);
        setFade(true);
      }, 200);
    }, interval);
    return () => clearInterval(id);
  }, [shuffledMessages.length, interval]);

  return { message: shuffledMessages[msgIndex], fade };
}

const SiteLoadingPageWithOverlay = () => {
  const { message, fade } = useRotatingMessage(standardMsgs, 2800);

  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center backdrop-blur-sm bg-white/60">
      <div className="relative w-[120px] h-[120px] mb-6">
        <svg
          width={120}
          height={120}
          viewBox="0 0 120 120"
          className="absolute top-0 left-0 animate-hero-spin"
        >
          <circle
            cx="60"
            cy="60"
            r="54"
            fill="none"
            stroke="var(--sapphire-10)"
            strokeWidth="4.5"
          />
          <circle
            cx="60"
            cy="60"
            r="54"
            fill="none"
            stroke="var(--sapphire-100)"
            strokeWidth="5"
            strokeDasharray="120 220"
            strokeLinecap="round"
          />
        </svg>

        <svg
          width={60}
          height={60}
          viewBox="0 0 60 60"
          className="absolute top-[30px] left-[30px] animate-hero-spin-reverse"
        >
          <circle
            cx="30"
            cy="30"
            r="24"
            fill="none"
            stroke="var(--sapphire-10)"
            strokeWidth="3.5"
          />
          <circle
            cx="30"
            cy="30"
            r="24"
            fill="none"
            stroke="var(--sapphire-70)"
            strokeWidth="4.5"
            strokeDasharray="50 100"
            strokeLinecap="round"
          />
        </svg>

        <div className="absolute top-1/2 left-1/2 w-9 h-9 rounded-[10px] bg-gradient-to-br from-sapphire-05 to-sapphire-10 border border-sapphire-20 flex items-center justify-center animate-hero-pulse">
          <img src={Robot} alt="Criteria" />
        </div>

        <div className="absolute top-2 right-1.5 w-2 h-2 rounded-full bg-sapphire-40 animate-float-dot-1" />
        <div className="absolute bottom-3 left-0.5 w-1.5 h-1.5 rounded-full bg-sapphire-40 opacity-70 animate-float-dot-2" />
        <div className="absolute top-5 -left-1 w-[5px] h-[5px] rounded-full bg-sapphire-40 opacity-50 animate-float-dot-3" />
      </div>

      <div
        className={`text-[15px] font-medium text-charcoal-100 text-center min-h-6 max-w-[320px] transition-opacity duration-200 ${
          fade ? "opacity-100" : "opacity-0"
        }`}
      >
        {message}
      </div>
    </div>
  );
};

export default SiteLoadingPageWithOverlay;
